// extracted by mini-css-extract-plugin
module.exports = {"allWrap":"Kiosk_allWrap__1infB","kioskWrap":"Kiosk_kioskWrap__4IfoL","card":"Kiosk_card__11rqD"};